import React, { useRef, useState } from "react";
import { apiFetch } from "../../api/api";
import { getOrgMediaPath } from "../../utils/media/getOrgMediaPath";

const UploadSettings = ({ config, index, handleBlockChange }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  // 🔑 Resolve URLs from stored S3 keys
  const resolvedUrl = config.url ? getOrgMediaPath(config.url) : null;
  console.log("config-22", config);
  const resolvedPoster =
    config.thumbnailUrl
      ? getOrgMediaPath(config.thumbnailUrl)
      : null;
      const get1 = getOrgMediaPath(config.thumbnailUrl);
      const get2 = (config.thumbnailUrl);
      console.log("get1", get1);
      console.log("get2", get2);

  const previewSrc =
    config.mediaType === "video"
      ? resolvedPoster || resolvedUrl // fallback if thumb not ready yet
      : config.url;

  const handleSelectFile = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);

      const meta = await apiFetch("/media/upload-url", {
        method: "POST",
        body: JSON.stringify({
          mimeType: file.type,
          originalName: file.name,
          type: config.mediaType || "image",
        }),
      });

      await fetch(meta.uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      });

      const mediaRecord = await apiFetch("/media", {
        method: "POST",
        body: JSON.stringify({
          orgId: meta.orgId,
          type: config.mediaType || "image",
          s3Bucket: meta.bucket,
          s3Key: meta.key,
          mimeType: file.type,
          originalName: file.name,
          size: file.size,
        }),
      });

      handleBlockChange(index, "url", mediaRecord.s3Key);

      if (mediaRecord.thumbnailKey) {
        handleBlockChange(index, "thumbnailUrl", mediaRecord.thumbnailKey);
      }

    } catch (err) {
      console.error(err);
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ background: "#fff", padding: 10 }}>

      <input
        ref={fileInputRef}
        type="file"
        accept={config.mediaType === "video" ? "video/*" : "image/*"}
        hidden
        onChange={handleFileChange}
      />

      {/* PREVIEW */}
      {previewSrc && (
        <div
          style={{
            width: "100%",
            maxWidth: 320,
            aspectRatio: "16 / 9",
            marginTop: 10,
            border: "1px solid #ccc",
            borderRadius: 4,
            overflow: "hidden",
            background: "#111",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={previewSrc}
            alt="Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              background: config.mediaType === "video" ? "#111" : "#fff",
            }}
          />
        </div>
      )}

      {/* VIDEO OPTION */}
      {config.mediaType === "video" && (
        <div className="input-pair">
          <label>
            <input
              type="checkbox"
              checked={!!config.autoAdvance}
              onChange={(e) =>
                handleBlockChange(index, "autoAdvance", e.target.checked)
              }
            />
            Auto-advance when video ends
          </label>
        </div>
      )}

      {/* WIDTH */}
      <div className="input-pair">
        <label>Width</label>
        <input
          type="range"
          min="10"
          max="100"
          value={parseInt(config.size || "100")}
          onChange={(e) =>
            handleBlockChange(index, "size", `${e.target.value}%`)
          }
        />
        {config.size}
      </div>

      {/* ALIGNMENT */}
      <div className="input-pair">
        <label>Alignment</label>
        <select
          value={config.align || "left"}
          onChange={(e) =>
            handleBlockChange(index, "align", e.target.value)
          }
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  );
};

export default UploadSettings;
